module.exports = __webpack_public_path__ + "static/media/BGPSPAHBP.c3791180.pdf";